import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function PurchaseSection() {
  const {
    t
  } = useLanguage();
  const handlePurchase = () => {
    window.location.href = 'https://www.mentefluir.com/cart/44741027889199:1';
  };
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-20px',
    amount: 0.2
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="my-12 md:my-20 py-10 md:py-16 px-5 md:px-6 bg-gradient-to-br from-[#2C4A3E] to-[#3D5F4E] rounded-2xl border-[3px] border-[#D4A574] shadow-xl" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#FBF8F3] text-center mb-8 md:mb-12" data-id="element-65">
          {t.purchase.title}
        </h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-66">
          {/* Devices Image */}
          <div data-id="element-67">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/usvF4ccLCCwBP2gg2iaurJ/Dispositivos_mostrando_e-book_sobre_sanacion_financiera.png" alt="E-book on devices" className="w-full rounded-lg shadow-2xl" loading="lazy" decoding="async" data-id="element-68" />
          </div>

          {/* Purchase Details */}
          <div className="space-y-6 md:space-y-8" data-id="element-69">
            {/* Price Badge */}
            <div className="text-center md:text-left" data-id="element-70">
              <div className="inline-block bg-gradient-to-br from-[#E8B86D] via-[#D4A574] to-[#C87941] rounded-2xl px-6 md:px-8 py-3 md:py-4 mb-4 md:mb-6" data-id="element-71">
                <div className="flex items-baseline gap-2" data-id="element-72">
                  <span className="text-4xl md:text-5xl font-bold text-[#2C4A3E]" data-id="element-73">
                    {t.purchase.price}
                  </span>
                  <span className="text-lg md:text-xl text-[#2C4A3E]" data-id="element-74">
                    {t.purchase.priceLabel}
                  </span>
                </div>
              </div>
            </div>

            {/* Features */}
            <ul className="space-y-3 md:space-y-4" data-id="element-75">
              {t.purchase.features.map((feature, index) => <li key={index} className="flex items-start gap-3 text-[#FBF8F3]" data-id="element-76">
                  <CheckIcon className="w-5 h-5 md:w-6 md:h-6 text-[#D4A574] flex-shrink-0 mt-1" data-id="element-77" />
                  <span className="text-base md:text-lg" data-id="element-78">{feature}</span>
                </li>)}
            </ul>

            {/* CTA Button */}
            <motion.button onClick={handlePurchase} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gradient-to-br from-[#E8B86D] via-[#D4A574] to-[#C87941] text-[#2C4A3E] py-4 md:py-5 rounded-xl text-lg md:text-xl font-bold transition-all duration-300 text-center cursor-pointer" data-id="element-79">
              {t.purchase.button}
            </motion.button>

            {/* Trust Indicators */}
            <div className="flex items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-[#FBF8F3]/80" data-id="element-80">
              <span data-id="element-81">🔒 {t.purchase.secure}</span>
              <span data-id="element-82">⚡ {t.purchase.instant}</span>
            </div>
          </div>
        </div>
      </div>
    </motion.section>;
}